'use client';
import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import ProductCard from '@/components/products/ProductCard';

const BestSellersListSkeleton = () => {
  return (
    <Grid
      templateColumns={{
        desktop: 'repeat(5, 1fr)',
        base: 'repeat(2, 1fr)',
      }}
      tablet={{
        '& > *:nth-of-type(n+5)': {
          display: 'none',
        },
      }}
      desktop={{
        '& > *:nth-of-type(n+5)': {
          display: 'initial',
        },
      }}
      gap={3}
      width="100%"
    >
      {[1, 2, 3, 4, 5].map((item) => (
        <GridItem key={item}>
          <ProductCard.Skeleton orientation="vertical" width="100%" />
        </GridItem>
      ))}
    </Grid>
  );
};

export default BestSellersListSkeleton;
